__turbopack_context__.v({
  "typewriter": "Typewriter-module-scss-module__Rmu_QG__typewriter",
});
